import { GlobalAxios } from "../axios/axios-config";
import { ISurgeryType } from "../models/surgery-type";

const SURGERY_TYPE_ROUTE =
  process.env.REACT_APP_EXTERNAL + "/api/v1/SurgeryType/SurgeryType";

export const surgeryTypeList = (params?: any) => {
  return GlobalAxios.get<ISurgeryType[]>(SURGERY_TYPE_ROUTE, {
    params,
  });
};
